import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { ClosedSilobagData, SilobagClosePayload } from './silobag-close.types';

// deprecated service ref.: closeSilobag_DEPRECATED

// implementado ✅
export async function closeSilobagService({ query: rawQuery, body }: SilobagClosePayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.post<ClosedSilobagData>(ENDPOINT.SILOBAG_CLOSE, { query, body });

  return {
    response,
    summary: data,
  };
}
